<ng-container *ngIf="initialized && dto">
    <div class="p-3">
        <mvs-widget *ngIf="blueprintWidget" [widgetData]="blueprintWidget"></mvs-widget>
    </div>
</ng-container>
